// Pressed-state feedback for touch devices.
// iOS fires :active too late (or not at all) on quick taps, so we drive the
// effect from touch events and hold it long enough to be visible.

const PRESSED_CLASS = 'is-pressed'
const MIN_VISIBLE_MS = 200
const MOVE_CANCEL_PX = 10

let pressed = null
let pressedAt = 0
let startX = 0
let startY = 0

const release = (immediate = false) => {
    if (!pressed) return

    const el = pressed
    pressed = null

    const remaining = immediate ? 0 : Math.max(0, MIN_VISIBLE_MS - (Date.now() - pressedAt))
    setTimeout(() => el.classList.remove(PRESSED_CLASS), remaining)
}

document.addEventListener('touchstart', (e) => {
    const target = e.target.closest('[data-tap]')
    if (!target) return

    release(true)
    pressed = target
    pressedAt = Date.now()
    startX = e.touches[0].clientX
    startY = e.touches[0].clientY
    target.classList.add(PRESSED_CLASS)
}, { passive: true, capture: true })

document.addEventListener('touchmove', (e) => {
    if (!pressed) return

    // A drag means the user is scrolling, not tapping
    const dx = e.touches[0].clientX - startX
    const dy = e.touches[0].clientY - startY
    if (Math.hypot(dx, dy) > MOVE_CANCEL_PX) release(true)
}, { passive: true, capture: true })

document.addEventListener('touchend', () => release(), { passive: true, capture: true })
document.addEventListener('touchcancel', () => release(true), { passive: true, capture: true })
